<template>
  <div class="langback" v-if="$i18n.locale=='es'">
    <button class="languagebutton"
      v-for="language in languages" 
      :key="language.locale"
      @click="changeLanguage(language.locale)" >
        <label v-if="language.locale == 'en'">EN</label> 
        <label class="ml-1" v-if="language.locale == 'de'">DE</label>
    </button>
  </div>
  <div class="langback" v-else-if="$i18n.locale=='en'">
    <button class="languagebutton"
      v-for="language in languages" 
      :key="language.locale"
      @click="changeLanguage(language.locale)" >
        <label v-if="language.locale == 'es'">ES</label> 
        <label class="ml-1" v-if="language.locale == 'de'">DE</label>
    </button>
  </div>
  <div class="langback" v-else-if="$i18n.locale=='de'">
    <button class="languagebutton"
      v-for="language in languages" 
      :key="language.locale"
      @click="changeLanguage(language.locale)" >
        <label v-if="language.locale == 'es'">ES</label> 
        <label class="ml-1" v-if="language.locale == 'en'">EN</label>
    </button>
  </div>
</template>



<script>
import { i18n } from '@/plugins/i18n'
import { text } from 'body-parser';
export default {
  name: 'LanguageComponent',
  data: () => ({
    languages: [
      { locale: 'es', title: 'Español', img:"es_ES.png"},
      { locale: 'en', title: 'Inglés' , img:"en_US.png"},
      { locale: 'de', title: 'Alemán' , img:"de_DE.png" }
    ]
  }),
  methods: {
    changeLanguage(locale) {
      i18n.locale = locale
    }
  }
}
</script>
<style lang="scss"> 
.langback {
  margin-right: 0.3rem;
  height: 30px;
  margin: 25px 15px 4px 20px;
  padding: 1px 0px 5px 15px;
  border-radius: 27px;
  background-color: rgba(255, 255, 255, .8);
  width: 80px;
}

.languagebutton {
  font-size: 0.9rem;
  font-weight: bolder;
  color: #6D8E28;
}
</style>


// WEBPACK FOOTER //
// src/components/Lenguaje.vue